<div class="AddSegmentMain" *ngIf="isAddSegment">
    <div class="topInputsContainer">
        <div class="row-new add-first">
            <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4 segment-align">
                <span class="form-inline-new">
                    <p class="funding-headers">Funding Segment</p>
                </span>
                <input Placeholder="Enter Funding Segment" (input)="disableAddSegment();" [(ngModel)]="fundingSegment" class="name-add-input lob-border">
            </div>
        </div>
        <div class="fundingSourceContainer col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
            <span class="form-inline-new">
                <p class="funding-headers funding-headers-delegates">Funding Source</p>
            </span>
            <mat-form-field appearance="outline">
                <mat-select panelClass="overlay-width-group"
                [(ngModel)]="fundingSourceSelected.name" (selectionChange)="onFundingSegmentChange($event)">
                <mat-option class="dropDownList" *ngFor="let source of fundingSourceDropdownList" [value]="source.name">
                    <ng-container>
                    {{source.name}}
                    </ng-container>
                </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row-new lob-architect-row">
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
            <span class="form-inline-new">
                <p class="funding-headers funding-headers-delegates">Funding Owner</p>
            </span>
            <div class="funding-chip-field lob-border">
                <ng-container class="example-chip-list">
                    <mat-form-field (click)="focusOnInput('addOwner')" *ngIf="AddSegmentUpdate.FundingOwner" class="inline-form-edit funding-names-chip chip-fields" floatLabel="never">
                        <mat-chip-grid #chipList1>
                            <mat-chip-row class="stk-mat-chip" *ngFor="let owner of AddSegmentUpdate.FundingOwner"
                                (removed)="removeOwnerAndDeligate(owner, 'Funding_Owner')">
                                <span title="{{owner.msid}}" style="cursor: pointer;">
                                    {{owner.displayName}}
                                </span>
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        </mat-chip-grid>
                        <input #inputAddOwner class="funding-chip-input" placeholder="Search by Name/Mail" [matAutocomplete]="auto"
                            (keyup)="keyUpSearch($event)" [matChipInputFor]="chipList1"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                        <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                            (optionSelected)="AddFundingOwner($event, 'Funding_Owner')">

                            <mat-option *ngFor="let user of users" [disabled]="checkExistUser(user, 'Funding_Owner', 'Add')" 
                                title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})" [value]="user">
                                {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </ng-container>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
            <span class="form-inline-new">
                <p class="funding-headers funding-headers-delegates">Funding Delegate</p>
            </span>
            <div class="funding-chip-field lob-border">
                <ng-container class="example-chip-list">
                    <mat-form-field (click)="focusOnInput('addDelegate')" *ngIf="AddSegmentUpdate.FundingSegment" class="inline-form-edit funding-names-chip chip-fields" floatLabel="never">
                        <mat-chip-grid #chipListdel>
                            <mat-chip-row class="stk-mat-chip" *ngFor="let delegate of AddSegmentUpdate.FundingSegment"
                                (removed)="removeOwnerAndDeligate(delegate, 'Funding_Delegate')">
                                <span title="{{delegate.MSId}}" style="cursor: pointer;">
                                    {{delegate.displayName}}
                                </span>
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        </mat-chip-grid>
                        <input #inputAddDelegate class="funding-chip-input" placeholder="Search by Name/Mail" [matAutocomplete]="auto"
                            (keyup)="keyUpSearch($event)" [matChipInputFor]="chipListdel"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                        <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                            (optionSelected)="AddFundingOwner($event, 'Funding_Delegate')">
                            <mat-option *ngFor="let user of users" [disabled]="checkExistUser(user, 'Funding_Delegate', 'Add')"  
                                title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})" [value]="user">
                                {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="pull-right add-apply-margin">
        <button mat-mdc-raised-button (click)="addSegment();" [disabled]="disableEdit" 
        class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
            Apply
        </button>
    </div>
</div>
